<template>
  <div class="service-content-container">
    <transition name="fade" mode="out-in">
      <div :key="contentname">
        <div class="contentservice-head ">
          {{ data[contentname].head }}
        </div>
        <div class="contentservice-content box-wrapper ">
          <div class="col font-prajad" v-html="data[contentname].content"></div>
        </div>
        <div class="contentservice-content box-wrapper mt-5 text-center row">
          <div
            v-for="(review, key) in data[contentname].review"
            :key="key"
            class="col-12 col-md mb-1"
          >
            <router-link
              v-if="data[contentname].review"
              :to="{ name: 'Review', hash: review }"
              class="button d-block w-100"
            >
              {{ key }}
            </router-link>
          </div>
        </div>
        <!-- slide img -->
        <div v-if="data[contentname].slide" class=" box-wrapper mt-4">
          <div class="content">
            <viewer
              :images="data[contentname].slide"
              style="cursor: pointer;"
              class="row m-0"
            >
              <img
                v-for="(slide, key) in data[contentname].slide"
                :key="key"
                class="w-100 col-xs-6 col-md-3 pb-2 img-item px-xs-0 px-md-2"
                :src="slide"
                :data-src="slide"
              />
            </viewer>
          </div>
        </div>
        <!-- contentservice img -->
        <div
          v-if="data[contentname].url"
          class="contentservice-image box-wrapper mt-5"
        >
          <div class="content">
            <iframe
              :src="data[contentname].url"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <!-- <img :src="require('@images/service/' + data[contentname].img)" /> -->
        </div>
        <ServiceBar />
      </div>
    </transition>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import ServiceBar from "./ServiceBar";
export default {
  name: "ServiceContent",
  components: {
    ServiceBar
  },
  props: {
    contentname: {
      type: String,
      required: true
    },
    components: {
      swiper,
      swiperSlide
    }
  },
  data() {
    return {
      data: {
        botox: {
          img: "",
          head: "Botox หรือ Botulinum toxin",
          content: `
<img class="w-100 pb-3" src="${require("@images/service/botox.jpg")}"/>
          Botox หรือ Botulinum toxin เป็นโปรตีนชนิดหนึ่งที่สกัดได้จากการสร้างของแบคทีเรีย “คลอสตริเดียม โบทูลินั่ม” (Clostridium botulinum) เชื้อโรคนี้หากได้รับมากเกินไปจะทำให้อาหารเป็นพิษหรือเกิดอาการกล้ามเนื้ออ่อนแรง แต่ถ้าได้รับในปริมาณน้อยๆ อย่างพอเหมาะ จะช่วยให้กล้ามเนื้อคลายตัวอันเป็นผลดีกับวงการแพทย์ ซึ่งนำมาใช้ในการรักษาโรคตาเหล่ ตาเข และยังเป็นผลดีในวงการเสริมความงาม นั่นก็คือช่วยให้ริ้วรอยต่างๆ ลดลงและกระชับผิวให้ดีขึ้น โดยสามารถเห็นผลลัพธ์หลังการฉีดได้ภายใน 2 – 3 วัน สำหรับรอยตื้นๆ และรอยลึกจะเห็นผลประมาณ 7 – 14 วัน <br><br>
          <p>การฉีดBotox เหมาะกับบริเวณไหนบ้าง</p>
          <ul>
            <li>รอยย่นหน้าผากและหว่างคิ้ว</li>
            <li>ริ้วรอยรอบดวงตา</li>
            <li>ริ้วรอยรอบดวงตา</li>
            <li>ลดกราม ทำให้หน้าเรียว และยกกระชับกรอบหน้า</li>
            <li>ลดเหงื่อบริเวณใต้</li>
          </ul>
          <p>ยี่ห้อที่แนะนำ</p>
          <ul>
            <li>Neuronox</li>
            <li>Hugel</li>
            <li>Allergan Botox สัญชาติอเมริกา ตัวที่ดีที่สุดและได้รับการยอมรับมากที่สุดจากทั่วโลก มีประสิทธิภาพในการลดริ้วรอยได้อย่างเป็นธรรมชาติ ไม่รู้สึกตึงจนเกินไป  เนื่องจากมีความบริสุทธิ์ของโปรตีนสูง ระยะเวลาในการทำงานและผลจะอบู่ได้นาน 8-12เดือน</li>
          </ul>
          `,
          url: "https://www.youtube.com/embed/xt_33o0nLLc"
        },
        elifting: {
          img: "",
          head: "Liftegra E-lifting",
          content: `
          Liftegra E-lifting เป็นนวัตกรรมการลดริ้วรอยใหม่จากเยอรมัน อุดมไปด้วยสารสกัดจากธรรมชาติที่ช่วยกระตุ้นโครงสร้างผิว บำรุงทำให้ผิวแข็งแรง กระตุ้นให้หลั่ง Growth factor ส่งผลให้ร่างกายสร้างคอลลาเจนและอิลาสตินเพิ่มมากขึ้น ซึ่งมีผลทำให้ริ้วรอยจางลง ผิวมีความชุ่มชื้น ทั้งนี้ยังมีสารต่อต้านอนุมูลอิสระ ช่วยในการชลอวัยแลดูอ่อนเยาว์ <br><br>
          <p>Results</p>
          <ul>
            <li>ฟื้นฟูสภาพผิวเดิม แก้ความหมองคล้ำ ให้กระจ่างใส</li>
            <li>ลดเลือนริ้วรอย และรอยจากผิวที่แห้งกร้าน</li>
            <li>ลดริ้วรอยใต้ตา ริ้วรอยหน้าผาก</li>
            <li>ลดเลือนร่องน้ำหมากให้ตื้นขึ้น</li>
            <li>ยกกระชับร่องแก้ม หางตา หางคิ้ว</li>
            <li>ยกกระชับกรอบหน้า และลดกราม ทำให้กรอบหน้าชัดและใบหน้าแลดูเล็กลง</li>
            <li>เพิ่มสันจมูก ทำให้แลดูคม และเงา</li>
            <li>ลดรอยย่นบริเวณคอ</li>
          </ul>
          <br>
          <p>
            <table width="100%" border="1">
              <tr>
                <td style="text-align:center">Botox</td>
                <td style="text-align:center">E-Lifting	
              </tr>
              <tr>
                <td>เป็น toxins</td>
                <td>เป็นสารธรรมชาติที่ทำงานคล้าย botox</td>
              </tr>
              <tr>
                <td>ทำให้กล้ามเนื้ออ่อนแรง ฉีดมากเกินไปทำให้บริเวณที่ฉีดตึงและแข็ง ขยับหน้าลำบาก</td>
                <td>ทำให้กล้ามเนื้ออ่อนแรง ฉีดมากเกินไปทำให้บริเวณที่ฉีดตึงและแข็ง ขยับหน้าลำบาก</td>
              </tr>
              <tr>
                <td>ฉีดแก้ปัญหาได้เฉพาะจุดบนใบหน้า</td>
                <td>ฉีดแก้ริ้วรอยได้ทั่วใบหน้า</td>
              </tr>
              <tr>
                <td>ฉีดแก้ริ้วรอยได้ทั่วใบหน้า</td>
                <td>ฉีดบ่อย ยิ่งฉีดห่าง และผลลัพดีขึ้นเรื่อยๆ</td>
              </tr>
              <tr>
                <td>ผลข้างเคียงหากฉีดผิดจุด</td>
                <td>ผลข้างเคียงหากฉีดผิดจุด</td>
              </tr>
            </table>
          </p>
          `
        },
        filler: {
          img: "",
          head: "Filler ฟิลเลอร์",
          content: `
          ฟิลเลอร์ คือสารคงตัวที่มีส่วนผสมของไฮยาลูโรนิกแอซิด (Hyaluronic Acid หรือ HA) ซึ่งเป็นสารที่มีความคงตัวสูง มีคุณสมบัติในการดูดสารน้ำ เป็นสารที่เรามีอยู่ในร่างกายอยู่แล้วปลอดภัย และไม่เป็นอันตราย นอกจากนี้ยังสามารถสลายไปเองได้โดยไม่เหลือสารตกค้าง <br><br>
          หน้าที่หลักของฟิลเลอร์คือ ดูดซับน้ำเอาไว้เพื่อพองตัวทำให้บริเวณที่ฉีดเข้าไปเกิดการเติมเต็ม ผลที่ได้รับคือลดร่องลึก ลดรอยเหี่ยวย่น ทำให้ผิวหนังบริเวณนั้นตึงขึ้น ทั้งยังช่วยกระชับใบหน้าอีกด้วย <br><br>
          <p>ตำแหน่งที่สามารถฉีดฟิลเลอร์ได้</p>
          <ul>
            <li>ใต้ตา ฉีดเพิ่มเติมเต็มร่องลึกใต้ตา แก้ไขให้ดูเรียบเนียนมากขึ้น</li>
            <li>ตีนกา เติมร่องตีนกาให้ตื้นขึ้น</li>
            <li>รอยลึกร่องแก้มและร่องน้ำหมาก </li>
            <li>คาง เติมให้คางเรียวยาวดูเป็นธรรมชาติ</li>
            <li>ริมฝีปาก เติมเต็มทำให้ปากดูอวบอิ่มและชุ่มช่ำ</li>
            <li>บริเวณหน้าแก้ม ทำให้ดูอิ่มหน้าไม่หย่อนคล้อย และมีแก้มส้มดูเด็กลง</li>
            <li>ขมับ แก้ปัญหาขมับตอบ หรือปัญหาโหนกแก้มที่ดูสูงใหญ่ให้ดูเล็กและเบาลง</li>
          </ul>
          <p>ยี่ห้อที่แนะนำ</p>
          <ul>
            <li>Juvederm</li>
            <li>Restylane</li>
          </ul>
          `,
          url: "https://www.youtube.com/embed/VF593uXh9og"
        },
        lipothread: {
          img: "",
          head: "Lipo-thread",
          content: `
          เป็นผลึกคล้ายเส้นไหมแบบย่อยสลายได้ ผลิตมาจากสารสกัดจากธรรมชาติชนิด เดียวเดียวกับ lipofit โดยทำ ให้เป็นผลึก<br><br>
          ทำหน้าที่สลายไขมัน พร้อมยกกระชับในทันที แต่ Duration นานกว่าคือ 14 วัน  จะทา งานต่อเนื่อง  1-14 วันจึง จะสลายหมด ในชั้นไขมัน (Subcutaneous) โดยผ่านกระบวนการ  Metabolism ของร่างกาย ให้เป็นพลังงาน เหงื่อ และปัสสาวะ  โดยไม่ทิ้งสารตกค้างภายใน ร่างกาย<br><br>
          เมื่อฝังตามร่างกายตามจุดฝังเข็ม จะช่วยกระตุ้นการแตกตัวของไขมัน กระตุ้นการ เผาผลาญ และการไหลเวียนโลหิต พร้อมขจัดสารพิษ ช่วยขับของเสียออกจาก ร่างกาย เช่น ทางเหงื่อ ปัสสาวะ อุจจาระ เป็นต้น เป็นการปรับสมดุลในร่างกาย ตามหลัก homeotherapy<br><br>
          `,
          url: "https://www.youtube.com/embed/8O32aqo4JY4"
        },
        meltMe: {
          img: "",
          head: "Melt Me",
          content: `
          <img class="w-100 pb-4" src="${require("@images/service/meltMe/RF-01.jpg")}"/>
           นวัตกรรมใหม่ในการลด สลายไขมันรูปร่าง
          ดีไซน์รูปร่าง โดยไม่ต้องผ่าตัด, ดูดไขมัน และ ไม่ต้องพักฟื้น<br><br>
          โดยใช้พลังงานคลื่น RF  รุ่นล่าสุด นวดบนร่างกายซึ่งมี  License (เทคนิคเฉพาะของทางคลินิก) และ Lipo Thread ซึ่งเป็นเส้นไหมที่ย่อยสลายได้มีความยาว 1 ซม. เน้นการฝังตามจุดฝังเข็มหรือบริเวณที่มีไขมันหนาแน่นตามร่างกาย โดยใช้ 10 เส้นขึ้นไป (ตามขนาดตัวของคนไข้) เทคนิคการรักษาลงระดับที่ลึกถึงชั้นไขมัน เฉพาะ Revealing Clinic จึงนับได้ว่าเป็นนวัตกรรมใหม่ของการสลายไขมัน ซึ่งเป็นอีกทางเลือกให้กับคนไข้อีกทาง
          `,
          slide: [
            require("@images/service/meltMe/RF-03.jpg"),
            require("@images/service/meltMe/RF-04.jpg"),
            require("@images/service/meltMe/RF-06.jpg"),
            require("@images/service/meltMe/RF-07.jpg")
          ]
        },
        lipofit: {
          img: "",
          head: "Lipo-fit",
          content: `
          สารสกัดจากธรรมชาติและเทคโนโลยีสลายไขมันจากประเทศเยอรมัน ช่วยในการกระตุ้นการแตกตัวของไขมัน ผ่านทางระบบการเผาผลาญของร่างกาย ผลที่ได้นอกจากจะลดไขมันเฉพาะส่วนได้ดี ยังลดการแพ้และอาการบวมได้ นอกจากนี้ยังช่วยตับในการขับของเสีย จึงลดอาการเหนื่อยล้าขับสารพิษตกค้าง ฟื้นคืนผิวให้มีชีวิตชีวาได้<br><br>
          <p>ข้อแตกต่างระหว่าง Cosmofy (Homeopathy) กับ Mesofat ทั่วไป </p>
          <ul>
            <li>ไม่มี Phosphatidylcholine ซึ่งเป็นสารสกัดจากถั่วเหลือง ไข่แดง ซึ่งคนไข้ บางรายอาจแพ้ได้</li>
            <li>เบสเป็นน้ำปลอดภัยด้วยสารสกัดจากธรรมชาติ ผ่านการรับรอง  มาตรฐาน เช่น GMP, FDA, HALAL เป็นต้น</li>
            <li>เจาะเซลล์ไขมัน ดึงน้ำและไขมันออกจากเซลล์ ทำให้ลดไขมันได้ถาวร หากน้ำหนักไม่ขึ้นเกิน 3-5kg. </li>
            <li>ลดไขมัน พร้อมยกกระชับในทันที ไม่หย่อนคล้อย  </li>
            <li>เห็นผลเร็ว 20-30% ตั้งแต่ครั้งแรก </li>
            <li>ไม่ต้องฉีดซ้ำบ่อยครั้ง  </li>
            <li>ใช้ยาต่อจุดปริมาณน้อย แต่ได้ผลที่มีประสิทธิภาพ</li>
            <li>สามารถทานอาหารและดื่มแอลกอฮอล์ได้ปกติ โดยไม่มีผลต่อการบวม</li>
          </ul>
          `
        },
        lifting: {
          img: "service-06.png",
          head: "Thread-lifting (ร้อยไหม)",
          content: `
          <ul>
            <li>Cog</li>
		        <li>PDO</li>
          </ul>
          `
        },
        collagen: {
          img: "",
          head: "Made collagen (มาเด้)",
          content: `
          เป็นส่วนผสมจากสารสกัดทางธรรมชาติ ที่มีทั้งวิตามินรวม แร่ธาตุ เอนไซม์ และเซลล์บำบัด Placenta และคอลลาเจน ซึ่งเป็นอาหารผิวและช่วยขับสารพิษออกจากร่างกาย ทำให้สุขภาพผิวกลับมาดีและแข็งแรงมากขึ้น<br><br>
          <p>ประโยชน์</p>
          <ul>
            <li>ช่วยรักษาสิวเรื้อรัง สิวฮอร์โมน สิวอักเสบ</li>
            <li>ช่วยรักษาอาการแพ้เรื้อรัง ผื่นภูมิแพ้ผิวหนัง MADE จะช่วยทำให้เซลล์ผิวแข็งแรงขึ้น โดยมีการสร้างเซลล์ผิวใหม่มากขึ้น ทำให้ผิวทนทานต่อสารที่ทำให้แพ้ต่างๆได้ดีขึ้น</li>
            <li>ช่วยทำให้การหมุนเวียนของเลือด และปรับสมดุลของฮอร์โมน</li>
            <li>ช่วยเสริมสร้างคอลลาเจน ฟื้นฟูผิวให้ขาวกระจ่างใส</li>
            <li>ช่วยล้างสารพิษบนใบหน้า</li>
            <li>สำหรับผู้ที่ไม่มีปัญหาผิว ก็สามารถรักษาได้ เสมือนเป็นการให้อาหารผิว ช่วยให้ผิวแข็งแรง เกิดการผลัดเซลล์ผิวใหม่บ่อยขึ้น ช่วยให้ผิวสดใสเปล่งปลั่ง</li>
          </ul>
          `
        },

        ha135: {
          img: "",
          head: "Filorga HA135 (ฟิลอก้า)",
          content: `Filorga's NCTF 135 HA คือผลิตภัณฑ์ที่ใช้สำหรับการฟื้นฟู ดูแลซ่อมแซมและฟื้นฟูผิวแบบเข้มข้น เหมาะสำหรับการลดเลือน ร่องริ้วรอยลึก ช่วยยกกระชับผิว ไม่ให้ผิวหย่อนคล้อย ฟิลอก้ามีกรดไฮยาลูรอนิคเป็นส่วนผสมหลักที่สำคัญของผิวหนัง มีหน้าที่ในการช่วยซ่อมแซมผิวที่ถูกทำร้าย ซึ่งตัวการสำคัญที่ทำให้ ปริมาณกรดไฮยาลูรอนิคที่ร่างกายสามารถผลิตเองได้ตามธรรมชาติลดลง ได้แก่ แสงแดด และอายุที่เพิ่มขึ้น ก่อให้เกิดริ้วรอย รอยเหี่ยวย่นบนใบหน้า  นอกจากนี้ยังมีส่วนผสมอื่นๆที่เป็นประโยชน์ต่อการดูแลผิวพรรณ และช่วยลดเลือนริ้วรอยแห่งวัย ดังนี้ วิตามิน 14 ชนิด เช่น วิตามินเอ บี ซี และ อี ที่มีคุณสมบัติในการช่วยเสริมสร้างการทำงานของเซลล์ กรดอะมิโน 24 ชนิด ช่วยกระตุ้นการสังเคราะห์โปรตีนที่จะช่วยให้ร่างกายผลิตคอลลาเจน และอิลาสตินเพิ่มขึ้น สารแอนติออกซิแดนท์ 2 ชนิดที่จะช่วยกำจัดอนุมูลอิสระ ส่งผลให้เรามีสุขภาพร่างกายที่แข็งแรงขึ้น <br><br>
          <p>สามารถใช้ได้กับผิวหนังบริเวณ ดังต่อไปนี้ </p>
          <ul>
            <li>ทั่วใบหน้า </li>
            <li>บริเวณคอ</li>
            <li>บริเวณหลังมือ</li>
          </ul>
          <p>ได้รับผลการวิจัยจากศูนย์ประเทศฝรั่งเศส</p>
          <ul>
            <li>90% ช่วยปกป้องเซลล์จากสารอนุมูลอิสระ</li>
            <li>256% ช่วยสร้างคอลลาเจน</li>
            <li>72% ริ้วรอยจากผิวที่แห้งกร้านดูเลือนลง</li>
            <li>132% ผิวนุ่มชุ่มชื้น</li>
            <li>144% ผิวดูกระจ่างใส</li>
          </ul>
          `
        },
        bcc: {
          img: "",
          head: "BCC serum",
          content: `คือสารโปรตีนบริสุทธิ์ซึ่งเป็นอาหารเซลล์สูตรเข้มข้นกว่า 300ชนิด ช่วยในการซ่อมแซมผิวล้ำลึก รวมถึงช่วยกระตุ้นการสร้างคอลลาเจนชนิดที่ 1( ต้นกำเนิดของคอลลาเจนและอิลาสตินซึ่งเป็นโครงสร้างของผิวหนัง) ทั้งยังใช้นวัตกรรม Freeze-dried and Gramma radiation ในการคงประสิทธิภาพของอาหารเซลล์<br><br>
          <p>ประกอบด้วยอะไรบ้าง</p>
          <ul>
            <li>BCC POWDER โปรตีนบริสุทธิ์กว่า 300ชนิด ช่วยรักษาและป้องกันทุกปัญหาผิวตั้งแต่ต้นเหตุ</li>
            <li>BCC ACTIVATOR เซรั่มสารสกัดจากธรรมชาติ ช่วยในเรื่องความกระจ่างใสและกระตุ้นการสร้างคอลลาเจน</li>
          </ul>
          <p>ผลลัพธ์ที่ได้รับ</p>
          <ul>
            <li><span>Whitening effect :</span> ช่วยต้านสารอนุมูลอิสระ ทำให้ผิวขาวและกระจ่างใสกว่าการใช้วิตามินซีถึง 50%</li>
            <li><span>Anti-melasma :</span> ป้องกันและรักษาฝ้าตื้น ฝ้าลึก และกระ </li>
            <li><span>Anti-Wrinkle :</span> เนื่องจากการกระตุ้นคอลลาเจนและอิลาสตินให้ผิวชั้นลึก ทำให้ซ่อมแซมและฟื้นฟูเซลล์ผิวให้แข็งแรงขึ้น ทั้งยังปรับสมดุลภายในผิวทำให้ทำงานได้ปกติ ลดปัญหาริ้วรอย ยกกระชับผิวและกระชับรูขุมขน ให้ผิวเต่งตึงและเปล่งปลั่งมากยิ่งขึ้น</li>
            <li><span>Wound healing :</span> รักษาการอักเสบของผิว ลดรอยดำจากสิว หลุมสิว และสิวผด</li>
          </ul>
          `,
          url: "https://www.youtube.com/embed/S9oq-U-TFbc"
        },
        lumigen: {
          img: "",
          head: "Lumigen acne",
          content: `สารสกัดธรรมชาติ จากประเทศเยอรมัน ที่มีมากับคอนเซปง่ายๆว่า Homeopathic concept for skin detoxification ตัวยาที่ทำงานง่าย เร็วและทำงานตลอดเวลา<br><br>
          <p>คุณสมบัติ</p>
          <ul>
            <li>ปรับสมดุลผิว ลดผิวหน้ามัน และแก้ปัญหารูขุมขนกว้าง</li>
            <li>เพิ่มความชุ่มชื้นเติมอาหารผิว</li>
            <li>เร่งกระบวนการรักษาแผล</li>
            <li>ลดริ้วรอยร่องลึกให้ตื้นขึ้น</li>
            <li>ช่วยกระตุ้นคอลลาเจนเฉพาะที่ และกระตุ้นการไหลของต่อมน้ำเหลือง</li>
          </ul>
          `
        },
        prp: {
          img: "",
          head: "PRP (สเต็มเซลล์จากเลือด)",
          review: { "รีวิว PRP": "#review-6" },
          content: `PRP (สเต็มเซลล์จากเลือด)`,
          url: "https://www.youtube.com/embed/0jbJqnCLbuY"
        },
        placenta: {
          img: "",
          head: "Placenta (เซลล์ใหม่จากรก) Melmons",
          content: `คือ สารสกัดจากรก ของทารก (ส่วนที่เชื่อมต่อจากสายสะดือ) ซึ่งมีส่วนสำคัญในการสร้างเซลล์และสร้างภูมิคุ้มกันตามธรรมชาติ ที่สำคัญตัว Placenta (รก) ยังมี Stem cell stimulation factor activity ซึ่งจะช่วยกระตุ้น Stem cell ที่อยู่ในภาวะพักกลับมาทำงานเพื่อซ่อมแซมร่างกาย และผลัดเซลล์เก่าที่เสื่อมสภาพออกไป แล้วสร้างเซลล์ใหม่ขึ้นมาแทนที่ นอกจากนี้ยังกระตุ้นให้ร่างกายสร้างฮอร์โมนได้เอง ให้มีระดับฮอร์โมนใกล้เคียงกับในวัยหนุ่มสาว เช่น ฮอร์โมน HSG, HPL, HCC, ACTH, DHEA เป็นต้น คืนความสมดุลของกรด ด่างในเลือด และช่วยให้อวัยวะต่างๆทำงานได้ดีขึ้น<br><br>
          <p>ประโยชน์ </p>
          <ul>
            <li>ป้องกันการเกิดโรคที่เกี่ยวเนื่องมาจากความเสื่อมของเซลล์ เช่น ความดันโลหิตสูง เบาหวาน ไขมันในเลือดสูง เป็นต้น</li>
            <li>ช่วยกระตุ้นการสร้างสารอาหารจำเป็น และสร้างพลังงานหลังเกิดการเจ็บป่วย</li>
            <li>ช่วยให้บาดแผลหลังจากการผ่าตัดหรือเกิดการบาดเจ็บหายเร็วขึ้นและลดการเกิดแผลเป็น</li>
            <li>จำเป็นสำหรับหญิงในวัยใกล้หมดประจำเดือนหรือมีความแปรปรวนของระบบฮอร์โมน</li>
            <li>สำหรับผู้ป่วยโรคมะเร็งที่อยู่ระหว่างการรักษาในโรงพยาบาลซึ่งมีการให้เคมีบำบัดหรือการฉายแสง มีผลทำให้เซลล์อ่อนแอ Melsmon จะเข้าไปช่วยกระตุ้นให้เซลล์เหล่านั้นมีพลังงานมากขึ้น ร่างกายอ่อนเพลียลดลง</li>
            <li>กระตุ้นให้เกิดการผลัดเซลล์ผิวใหม่ บำรุงเซลล์ผิวหน้าให้เปล่งปลั่ง ลดรอยเหี่ยวย่นทำให้ดูอ่อนกว่าวัย</li>
          </ul>
          `
        },
        growth: {
          img: "",
          head: "Growth Factor (สเต็มเซลล์ตัวเต็มวัย)",
          content: `Growth Factor (สเต็มเซลล์ตัวเต็มวัย)`
        },
        stemcell: {
          img: "",
          head: "Stem cell (สเต็มเซลล์)",
          content: `<p>THAI<p>
          <p>Germany<p>
          <ul>
            <li>MSC (หน้า)</li>
            <li>Organ (อวัยวะ)</li>
          </ul>
          `
        },
        skinfood: {
          img: "",
          head: "Skin food (วิตามินอาหารผิว)",
          content: `
          <ul>
            <li>Pure white (สูตรขาวออร่า)</li>
            <li>Refresh skin (สูตรผลัดเซลล์ผิว)</li>
            <li>Revealing perfect white skin (สูตรพิเศษ)</li>
          </ul>
          `,
          url: "https://www.youtube.com/embed/LrpX_Brina0"
        },
        epn: {
          img: "",
          head: "EPN Course",
          content: `EPN course`
        },
        hifu: {
          img: "",
          head: "Microson HIFU (ไฮฟูยกกระชับ)",
          review: { "รีวิว Hifu": "#review-4" },
          content: `
          <img class="w-100 pb-2" src="${require("@images/service/hifu.jpg")}"/>
          เทคโนโลยี focus ultrasound ที่ดีที่สุดของบริษัท Eunsung ประเทศเกาหลี ช่วยในการยกกระชับผิวหนังให้กระชับ และทำให้กรอบหน้าคมมากขึ้น ด้วยเทคโนโลยีใหม่ทำให้ความแม่นยำในการยิงลึกเข้าชั้นผิวมีมากขึ้น ทั้งยังมีระบบในการป้องกันการเกิดรอยไหม้บนชั้นผิว<br><br>
          ด้วยเทคนิคการยิง2 หัวของคุณหมอ ทำให้ความละเอียดและความแข็งแรงในการยกกระชับแข็งแรงสวยและเป็นธรรมชาติมากขึ้น อย่างไรก็ตาม HIFU ยังช่วยกระตุ้นคอลลาเจน ทำให้หน้ากระจ่างใสมากขึ้น<br><br>
          <ul>
            <li>Radio frequency (คลื่นกระชับสัดส่วน)</li>
          <ul>
          `,
          url: "https://www.youtube.com/embed/CaMX7jtI9eU"
        },
        phiniplasty: {
          img: "",
          head: "Rhinoplasty (ศัลยกรรมจมูก)",
          content: `
          <img class="w-100 pb-2" src="${require("@images/service/rhinopasty.jpg")}"/>
          <p>New case (เคสเสริมใหม่)</p>
          <p>Revise rhinoplasty (เคสแก้จมูก)</p>
          <ul>
            <li>Revise (เคสแก้ใหม่)</li>
                <li>Revise with cartilage (เคสแก้จมูกหลังหู)</li>
                <li>Revise with megaderm /osteopore (เคสแก้เนื้อเยื่อเทียม)</li>
          </ul>
          `,
          url: "https://www.youtube.com/embed/nKk2qUOeJjc"
        },
        chinaugment: {
          img: "",
          head: "Chin Augmentation (ศัลยกรรมคาง)",
          content: `<p>New case (เคสเสริมใหม่)</p>
          <p>Revise (เคสแก้คาง)</p
          >`
        },
        fattransfer: {
          img: "",
          head: "Fat Grafting (เติมไขมัน)",
          review: { รีวิวเติมไขมันหน้าเด็ก: "#review-2" },
          content: `<p>Face (เติมไขมันหน้า)</p>
          <p>Breast (เติมไขมันหน้าอก) </p>
          `,
          url: "https://www.youtube.com/embed/Q_zhzODRROo"
        },
        liposuction: {
          img: "",
          head: "Liposuction (ดูดไขมัน)",
          review: {
            รีวิวดูดไขมันแขน: "#review-3",
            รีวิวดูไขมันหน้าท้อง: "#review-1",
            รีวิวดูไขมันขา: "#review-5"
          },
          content: `
           <img class="w-100" src="${require("@images/service/lipo.jpg")}"/>
           <p>Arm (ท้องแขน)</p>
          <p>Abdomen (หน้าท้อง และ เอว)</p>
          <p>Lower body (ช่วงล่าง)</p>
          <ul>
            <li>Outer thigh (สะโพกและต้นขาด้านนอก)</li>
            <li>Inner thigh (ต้นขาด้านใน)</li>
            <li>All (รวมช่วงขา เข่า และสะโพก)</li>
          </ul>
          `,
          url: "https://www.youtube.com/embed/Ja51WS6GkVk"
        }
      }
    };
  }
  // watch: {
  //   $route: {
  //     immediate: true,
  //     handler(to, from) {
  //       document.title = this.contentname || "บริการ";
  //     }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
@import "@scss/service/service_content";
@import "@scss/aspect-ratio";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.button {
  transition: opacity 0.3s ease-out;
  &:hover {
    opacity: 0.8;
  }
}

.contentservice-image {
  @include aspect-ratio(16, 9);
  iframe {
    width: 100%;
    height: 100%;
    padding: 0 7vw;
  }
}
</style>
